<!-- This component should replace the use of MembersAboutFields in other reports -->
<template>
  <ReportColumnToggle
    query-property="show_member_info"
    has-submenu
  >
    <div class="app-toggle-dropdown pr-5">
      <slot></slot>
      <ReportShowMemberInfoColumnToggleFields />
    </div>
  </ReportColumnToggle>
</template>

<script>
import { mapState } from 'vuex';
import ReportShowMemberInfoColumnToggleFields from '~/components/reports/ReportShowMemberInfoColumnToggleFields.vue';

export default {
  name: 'ReportShowMemberInfoColumnToggle',
  components: { ReportShowMemberInfoColumnToggleFields },
  computed: {
    ...mapState(['organization']),
    customFieldsList() {
      return this.organization.member_profile_fields;
    },
  },
};
</script>
